var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVersion(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7305 3.32031L9.67969 1.26953C9.35156 0.941406 8.91406 0.75 8.44922 0.75H4.375C3.39062 0.75 2.625 1.54297 2.625 2.5V10.375C2.625 11.3594 3.39062 12.125 4.375 12.125H10.5C11.457 12.125 12.25 11.3594 12.25 10.375V4.55078C12.25 4.08594 12.0586 3.64844 11.7305 3.32031ZM10.9375 10.375C10.9375 10.6211 10.7188 10.8125 10.5 10.8125H4.375C4.12891 10.8125 3.9375 10.6211 3.9375 10.375V2.52734C3.9375 2.28125 4.12891 2.08984 4.375 2.08984H7.875V4.25C7.875 4.74219 8.25781 5.125 8.75 5.125H10.9102V10.375H10.9375ZM8.96875 14.75H3.28125C1.44922 14.75 0 13.3008 0 11.4688V4.03125C0 3.67578 0.273438 3.375 0.65625 3.375C1.01172 3.375 1.3125 3.67578 1.3125 4.03125V11.4688C1.3125 12.5625 2.1875 13.4375 3.28125 13.4375H8.96875C9.32422 13.4375 9.625 13.7383 9.625 14.0938C9.625 14.4766 9.32422 14.75 8.96875 14.75Z",
    fill: "#CACED0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVersion);
export default __webpack_public_path__ + "static/media/version.b61c0907.svg";
export { ForwardRef as ReactComponent };